onDomLoad(() => {
  if (
    document.querySelector('[data-behaviour~="workflow-stacking-headers"]') !==
    null
  ) {
    document.querySelectorAll('.sf-table-sticky').forEach((tr, i) => {
      tr.setAttribute('style', '--sticky-offset: ' + (48 + i * 30) + 'px')
    })
  }
})
